

export const MINUTES = 'MINUTES';
export const HOURS = 'HOURS';
export const EVERY = '*';
